// extracted by mini-css-extract-plugin
export default {"CustomLink":"CustomLink_CustomLink__VZGgI"};